import externalComponent from '@/utils/external-component'
import { VirtualView, PatternView, View, ViewConfig } from './types'

import ExplorerList from '@/views/ExplorerList.vue'
import ExplorerAmos from '@/views/ExplorerAmos.vue'
import ExplorerTiles from '@/views/ExplorerTiles.vue'
import ExplorerJM from '@/views/ExplorerJM.vue'
import ExplorerJMFolder from '@/views/ExplorerJMFolder.vue'
import FileViewerImage from '@/views/FileViewerImage.vue'
import FileViewerVideo from '@/views/FileViewerVideo.vue'
import FileViewerGo from '@/views/FileViewerGo.vue'
import FileViewerHTML from '@/views/FileViewerHTML.vue'
import ExplorerGallery from '@/views/ExplorerGallery.vue'
import DUDCategories from '@/views/DUDCategoriesVV.vue'
import DUDHome from '@/views/DUDHome.vue'
import DUDDocuments from '@/views/DUDDocuments.vue'
import DUDAttachments from '@/views/DUDAttachments.vue'
import FileViewer from '@/views/FileViewer.vue'
import InfoPoint from '@/views/InfoPoint.vue'
import InfoPointFolder from '@/views/InfoPointFolder.vue'
import GlobusPricechecker from '@/views/GlobusPricechecker.vue'

export class MountVirtualView implements VirtualView {
  private views: PatternView

  constructor (views: PatternView) {
    this.views = views
  }

  Components (path: string): { [name: string]: View } {
    // console.log('MountVirtualView.Components', path)
    const key = Object.keys(this.views).find((pattern: string) => {
      return decodeURIComponent(path).match(new RegExp(pattern))
    })

    if (!key) {
      throw new Error(`can't find component for path ${path}`)
    }

    return this.views[key]
  }
}

export class InfoPointFolderVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return InfoPointFolder
  }
}

export class GlobusPricecheckerVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return GlobusPricechecker
  }
}

export class InfoPointVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return InfoPoint
  }
}

export class DUDDocumentsVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return DUDDocuments
  }
}

export class FileViewerVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return FileViewer
  }
}

export class DUDAttachmentsVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return DUDAttachments
  }
}

export class DUDHomeVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return DUDHome
  }
}

export class DUDCategoriesVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return DUDCategories
  }
}

export class ExplorerTilesVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return ExplorerTiles
  }
}

export class ExplorerListVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return ExplorerList
  }
}

export class ExplorerAmosVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return ExplorerAmos
  }
}

export class ExplorerGalleryVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return ExplorerGallery
  }
}

export class ExplorerJMVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return ExplorerJM
  }
}

export class ExplorerJMFolderVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return ExplorerJMFolder
  }
}

export class FileViewerGoVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return FileViewerGo
  }
}

export class FileViewerImageVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return FileViewerImage
  }
}

export class FileViewerHTMLVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return FileViewerHTML
  }
}

export class FileViewerVideoVV implements View {
  private config?: ViewConfig

  constructor (config?: ViewConfig) {
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  async Component (): Promise<any> {
    return FileViewerVideo
  }
}

export class ExplorerExternalVV implements View {
  private url: string
  private config?: ViewConfig

  constructor (url: string, config?: ViewConfig) {
    this.url = url
    this.config = config
  }

  Config (): Promise<ViewConfig> {
    return new Promise<ViewConfig>((resolve) => resolve(this.config))
  }

  Component (): Promise<any> {
    return externalComponent(this.url)
  }
}
